import type {BoardLane} from './board-lanes'
import stickyClasses from './swim-lane-sticky.module.css'

const LANE_STICKY_INDEX: Record<BoardLane, 0 | 1 | 2> = {
    needs_action: 0,
    notify_drivers: 1,
    dispatched: 2,
}

/** Stacked sticky positioning for swim-lane section headers. */
export function laneStickyHeaderClass(lane: BoardLane): string {
    const index = LANE_STICKY_INDEX[lane]
    return `${stickyClasses.laneStickyHeader} ${stickyClasses[`laneStickyHeader_${index}`]}`
}

export {stickyClasses}
